// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__23Rvj","loaderOuter":"PageOverlayLoader_loaderOuter__3ru3h"};